import { useEffect } from 'react';
import { useFocused, useSlateStatic } from 'slate-react';

import { placeCursorAtStart } from 'src/lib/slate';

/**
 * Initialize editor selection if it is empty after editor gets focused
 */
export const useInitSelection = () => {
  const editor = useSlateStatic();
  const focused = useFocused();

  useEffect(() => {
    if (focused && !editor.selection) {
      placeCursorAtStart(editor);
    }
  }, [focused, editor]);
};
